<template>
  <x-page :class="_.page" title="我的足迹">
    <template v-if="goodsData.length" slot="extra">
      <div
        v-if="isEdit"
        v-track="{
          name: '完成',
          id: 'cd4eccd5-1c1e-43c2-8a15-c56771f12bdd',
        }"
        :class="_.button"
        @click="isEdit = !isEdit"
      >
        完成
      </div>
      <div
        v-else
        v-track="{
          name: '编辑',
          id: '1d376ec3-969a-4b64-9ee0-d3a9b6b4acd8',
        }"
        :class="_.button"
        @click="isEdit = !isEdit"
      >
        编辑
      </div>
    </template>
    <x-goods-waterfall
      ref="list"
      :load="loadData"
      @change="data => (goodsData = data)"
    >
      <x-empty
        slot="empty"
        v-track="{
          name: '回到首页',
          id: '66f64234-6268-47f8-a47b-6154f891e2a9',
        }"
        message="没有浏览的足迹~"
        confirm-text="回到首页"
        @confirm="handleBackHomeClick"
      />
      <template #default="{ data }">
        <div :class="_.list">
          <template v-for="item in data">
            <div
              v-if="item.raw.showDate"
              :key="`title_${item.id}`"
              :class="_.title"
            >
              {{ formatDate(item.raw.showDate) }}
            </div>
            <div :key="item.id" :class="_.item">
              <van-checkbox
                v-if="isEdit"
                v-model="goodsSelectedMap[item.id]"
                :class="_.check"
              />
              <x-goods-cover
                :item="item"
                :class="_.cover"
                @click="handleGoodsClick(item)"
              />
              <div :class="_.content" @click="handleGoodsClick(item)">
                <div :class="[_.name, _._ellipsis2]">{{ item.name }}</div>
                <div v-if="item.tags.length" :class="_.tags">
                  {{ item.tags.join(' | ') }}
                </div>
                <div v-if="item.coupons.length" :class="_.coupons">
                  <div
                    v-for="coupon in item.coupons"
                    :key="coupon"
                    :class="_.coupon"
                  >
                    {{ coupon }}
                  </div>
                </div>
                <div :class="_.grow"></div>
                <div :class="_.extra">
                  <x-goods-price :goods="item" :class="_.price" />
                  <!-- 足迹不能加入购物车 -->
                  <div
                    v-if="false && !isEdit && !item.sold"
                    :class="_.cart"
                    @click.stop="handleCartClick(item)"
                  >
                    加入购物车
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </template>
    </x-goods-waterfall>
    <div v-if="isEdit && goodsData.length" :class="_.actions">
      <div :class="_.all">
        <van-checkbox v-model="allSelected" :class="_.check" />
        全选
      </div>
      <div
        v-track="{
          name: '删除',
          id: 'e5d64afa-344c-4521-bb6d-19d4925eecc0',
        }"
        :class="_.action"
        @click="handleDeleteClick"
      >
        删除({{ selectedGoods.length }})
      </div>
    </div>
    <div :class="_.placeholder"></div>
  </x-page>
</template>

<script>
  import Vue from 'vue'
  import {
    apiCommodityCommodityDelUserFootprint,
    apiCommodityCommodityGetUserFootprint,
    apiShoppingCartAdd,
  } from '@/api'
  import { Dialog } from 'vant'
  import { formatDate } from 'vtils/date'
  import { navigateTo } from '@/router'
  import { submit } from '@/utils'

  export default Vue.extend({
    data: () => ({
      isEdit: false,
      goodsData: [],
      goodsSelectedMap: {},
    }),

    computed: {
      selectedGoods() {
        return this.goodsData.filter(item => !!this.goodsSelectedMap[item.id])
      },
      allSelected: {
        get() {
          return this.selectedGoods.length === this.goodsData.length
        },
        set(bool) {
          this.goodsSelectedMap = bool
            ? this.goodsData.reduce((res, item) => {
                res[item.id] = true
                return res
              }, {})
            : {}
        },
      },
    },

    methods: {
      formatDate(date) {
        return formatDate(new Date(date), 'm月d日')
      },

      loadData({ pageNumber }) {
        return pageNumber === 1
          ? apiCommodityCommodityGetUserFootprint().then(res => {
              return res
                .map(item => {
                  if (item.commodityList.length) {
                    item.commodityList[0].showDate = item.createTime
                  }
                  return item.commodityList
                })
                .flat()
            })
          : []
      },

      handleBackHomeClick() {
        navigateTo('HomeIndex')
      },

      handleGoodsClick(item) {
        if (this.isEdit) {
          this.goodsSelectedMap = {
            ...this.goodsSelectedMap,
            [item.id]: !this.goodsSelectedMap[item.id],
          }
        } else {
          navigateTo('GoodsIndex', { id: item.id })
        }
      },

      handleCartClick(item) {
        submit(async $ => {
          $.start('加入购物车中...')
          await apiShoppingCartAdd({
            commodityId: item.id,
            quantity: 1,
            skuId: item.raw.skuId,
          })
          await $.success('加入购物车成功')
        })
      },

      handleDeleteClick() {
        submit(async $ => {
          const selectedGoods = this.selectedGoods
          if (!selectedGoods.length) {
            return $.fail('请先选择商品')
          }
          await Dialog.confirm({
            title: '确认删除已选择的商品？',
            confirmButtonText: '确认',
            cancelButtonText: '再想想',
          })
          $.start('删除中...')
          await apiCommodityCommodityDelUserFootprint({
            commodityIds: selectedGoods.map(item => item.id),
          })
          await this.$reloadWaterfall('list')
          await $.success('删除成功')
        })
      },
    },
  })
</script>

<style lang="scss" module>
  .page {
    :global {
      .van-checkbox__icon {
        font-size: 16px;
      }

      .van-checkbox__icon--checked .van-icon {
        background-color: rgba(255, 17, 28, 1);
        border-color: rgba(255, 17, 28, 1);
      }
    }
  }

  .button {
    font-size: 16px;
    font-weight: 400;
    color: #222222;
    line-height: 1;
  }

  .list {
    padding: 12px;
    background-color: white;

    .title {
      font-size: 16px;
      font-weight: bold;
      color: #222222;
      line-height: 22px;

      &:not(:first-child) {
        margin-top: 12px;
      }
    }

    .item {
      display: flex;
      align-items: stretch;

      .check {
        flex-shrink: 0;
        margin-right: 12px;
      }

      .cover {
        flex-shrink: 0;
        width: 100px;
        height: 100px;
      }

      .content {
        flex-grow: 1;
        margin-left: 8px;
        display: flex;
        flex-direction: column;

        .name {
          flex-shrink: 0;
          font-size: 14px;
          font-weight: bold;
          color: #333333;
          line-height: 20px;
        }

        .tags {
          flex-shrink: 0;
          margin-top: 8px;
          font-size: 12px;
          color: #999999;
          line-height: 17px;
        }

        .coupons {
          flex-shrink: 0;
          margin-top: 4px;
          display: flex;
          flex-wrap: wrap;

          .coupon {
            border-radius: 2px;
            border: 1px solid #ff111c;
            font-size: 12px;
            color: #ff111c;
            line-height: 12px;
            padding: 4px 6px;
            margin-right: 8px;
            margin-top: 4px;
            white-space: nowrap;
          }
        }

        .grow {
          flex-grow: 1;
        }

        .extra {
          margin-top: 8px;
          flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .cart {
            width: 80px;
            height: 28px;
            border-radius: 14px;
            border: 1px solid #979797;
            font-size: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #666666;
            line-height: 1;
          }
        }
      }

      &:not(:first-child) {
        margin-top: 12px;
      }
    }
  }

  .actions {
    position: fixed;
    // fix: iPhone 8 下不随滑动实时更新问题
    transform: translate3d(0, 0, 0);
    bottom: 0;
    left: 0;
    right: 0;
    height: 50px;
    background: #ffffff;
    box-shadow: 0px -2px 2px 0px rgba(245, 245, 245, 1);
    box-sizing: content-box;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 12px;

    .all {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #222222;

      .check {
        margin-right: 8px;
      }
    }

    .action {
      height: 38px;
      background: linear-gradient(131deg, #ff7e43 0%, #ff111c 100%);
      border-radius: 19px;
      padding: 0 15px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      font-weight: bold;
      color: #ffffff;
    }

    + .placeholder {
      height: 50px;
    }
  }
</style>
